import React, { useEffect, useRef, useState } from 'react';
import { apiService } from 'services/base.service';
import { BrandOption, MealCategoryType } from 'utils/types';

import SelectBrand from 'components/select-brand';
import ItemCategoryCard from 'components/item-category-card';
import { useSearchParams } from 'react-router-dom';

const ItemsCategoryListPage = () => {
  const pageHasLoaded = useRef(false);

  const [searchParams] = useSearchParams();
  const [itemCategories, setItemCategories] = useState<MealCategoryType[]>([]);
  const [selectedItem, setSelectedItem] = useState<BrandOption>({
    text: '',
    value: ''
  });
  const [loading, setLoading] = useState(false);

  const shopId = searchParams.get('shop') ?? '';

  const fetchCategoryData = async (reOrder?: boolean) => {
    if (!selectedItem || !selectedItem?.value) return;

    try {
      if (!reOrder) setLoading(true);
      const res: any = await apiService.get(`shops/${selectedItem.value}/categories`);
      setItemCategories(res?.data.data);
    } catch {
      setItemCategories([] as any);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (pageHasLoaded.current) fetchCategoryData();
    pageHasLoaded.current = true;
  }, [selectedItem]);

  useEffect(() => {
    setSelectedItem({ value: shopId, text: '' });
  }, [shopId]);

  return (
    <div className='w-full'>
      <div className='flex justify-between items-center gap-3 flex-wrap w-full mb-10'>
        <div className='max-w-[300px] w-full'>
          <SelectBrand
            selectFirstItem
            brands={selectedItem ? [selectedItem] : []}
            setBrands={([b]) => setSelectedItem(b)}
          />
        </div>
      </div>

      <div>
        {loading ? (
          <p className='flex justify-center items-center mt-48'>Loading</p>
        ) : itemCategories.length === 0 ? (
          <p className='flex justify-center items-center mt-48'>
            Select a shop in order to view item categories
          </p>
        ) : (
          <div className='grid gap-4 grid-cols-[repeat(auto-fill,_minmax(280px,_1fr))]'>
            {itemCategories.map((mealCategory) => (
              <ItemCategoryCard key={mealCategory.id} data={mealCategory} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemsCategoryListPage;
